import $ from 'jquery';
import 'tooltipster';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tv } from "../../lib/api/api";
import packageChannelsTooltip from "../../modules/package-channels-tooltip";

const ChannelLogoWithTooltip = ({channel}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [media, setMedia] = useState({});

    useEffect(() => {
        const elem = document.querySelector(`.js-channel-packs-tooltip-${channel}`);
        if ('init' in elem.dataset) {
            $(`.js-channel-packs-tooltip-${channel}`).tooltipster('destroy');
            $(`.js-channel-packs-tooltip-${channel}`).removeAttr('data-init');
        }
        tv.channel(channel)
            .then((res) => {
                setName(res.name);
                const index = Math.min(res.description.indexOf('\r\n'), res.description.indexOf('.'));
                setDescription(res.description.slice(0, index === -1 ? Math.max(res.description.indexOf('\r\n'), res.description.indexOf('.')) + 1 : index + 1));
                setMedia(res.media.default);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [channel]);

    useEffect(() => {
        if (name.trim() !== '') {
            packageChannelsTooltip(`.js-channel-packs-tooltip-${channel}`);
            const elem = document.querySelector(`.js-channel-packs-tooltip-${channel}`);
            elem.dataset.init = 'tooltip';
        }
    }, [name]);

    return (
        <>
            <li className="channel-description__logo-item">
                <Link className={`channel-description__channel-link js-channel-packs-tooltip-${channel}`} to={`//telekarta.tv/tvprogram/channel/${channel}/`} target="_blank" data-tooltip-content={`#channel-${channel}-logo-tooltip`}>
                    <img className="channel-description__channel-logo" src={media.url} width="40" height="40" alt={name}/>
                </Link>
                <div className="tooltipster-templates">
                    <div className="content-info__tooltip" id={`channel-${channel}-logo-tooltip`}>
                        <div className="content-info__tooltip-title">{name}</div>
                        <div className="content-info__tooltip-description">{description}</div>
                    </div>
                </div>
            </li>
        </>
    );
};

export default ChannelLogoWithTooltip;